export default "__VITE_ASSET__77bdccfe__"